var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _g3, _path9, _g4, _path10, _g5, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 133,
    viewBox: "0 0 446 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_778)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_778",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -33,
    y: -34,
    width: 511,
    height: 201
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M478 -33.2H-33V166.2H478V-33.2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.6 0H16.5C7.4 0.1 0 7.5 0 16.6V116.3C0 125.4 7.4 132.8 16.5 132.9H428.6C437.7 132.8 445.1 125.4 445.1 116.3V16.6C445.1 7.5 437.7 0.1 428.6 0ZM428.6 2.7C436.3 2.7 442.5 9 442.5 16.7V116.4C442.5 124.1 436.3 130.4 428.7 130.4H16.5C8.8 130.4 2.6 124.1 2.6 116.4V16.6C2.6 8.9 8.8 2.6 16.4 2.6L428.6 2.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.5 99.7H358.6V58.2H352.5V99.7ZM408 73.1L401 91.1H400.8L393.5 73.1H386.9L397.9 98.3L391.6 112.3H398L414.9 73.1H408ZM373.1 95C371.1 95 368.3 94 368.3 91.5C368.3 88.3 371.8 87.1 374.8 87.1C376.8 87 378.7 87.5 380.4 88.5C379.9 92.1 376.8 94.9 373.1 95ZM373.8 72.2C369.3 72.2 364.7 74.2 362.8 78.6L368.3 80.9C369.5 78.6 371.6 77.9 373.9 77.9C377.1 77.9 380.3 79.8 380.4 83.2V83.6C378.4 82.5 376.2 82 374 82C368.1 82 362.1 85.3 362.1 91.4C362.1 97 366.9 100.5 372.3 100.5C375.5 100.7 378.5 99.1 380.2 96.4H380.4V99.6H386.3V83.7C386.4 76.3 380.9 72.2 373.8 72.2ZM335.8 78.2H327V63.9H335.8C339.7 63.9 342.9 67.1 342.9 71C343 75 339.8 78.2 335.8 78.2C335.9 78.2 335.9 78.2 335.8 78.2ZM335.7 58.2H320.9V99.7H327V83.9H335.6C342.4 83.9 349.1 78.9 349.1 71C349.1 63.1 342.5 58.1 335.7 58.2ZM255.3 95C251.1 95 247.5 91.4 247.5 86.5C247.5 81.6 251.1 77.9 255.3 77.9C259.5 77.9 262.8 81.5 262.8 86.5C262.8 91.5 259.4 95 255.3 95ZM262.3 75.5H262.1C260.2 73.4 257.5 72.3 254.7 72.3C247.7 72.3 241.3 78.5 241.3 86.5C241.3 94.5 247.7 100.6 254.7 100.6C257.5 100.7 260.2 99.5 262.1 97.4H262.3V99.4C262.3 104.8 259.4 107.7 254.8 107.7C251.6 107.6 248.9 105.6 247.7 102.7L242.3 105C244.3 110.1 249.3 113.4 254.7 113.3C261.9 113.3 268 109 268 98.6V73.2H262.2V75.5H262.3ZM272.4 99.7H278.6V58.2H272.4V99.7ZM287.7 86C287.4 81.7 290.6 78.1 294.9 77.8C295 77.8 295 77.8 295.1 77.8C297.3 77.7 299.3 78.8 300.3 80.8L287.7 86ZM306.8 81.3C305.6 78.1 302.1 72.3 294.8 72.3C287.5 72.3 281.6 78 281.6 86.4C281.6 94.1 287.8 100.4 295.6 100.4C300.3 100.4 304.6 98.1 307.2 94.2L302.4 91C301 93.4 298.3 94.9 295.5 94.9C292.6 95 289.9 93.3 288.7 90.6L307.4 82.8L306.8 81.3ZM157.4 76.6V82.6H171.6C171.4 85.4 170.3 88.1 168.4 90.2C165.5 93.2 161.5 94.8 157.4 94.6C148.6 93.9 142 86.3 142.6 77.4C143.2 69.5 149.5 63.2 157.4 62.6C161.4 62.5 165.3 64.1 168.1 66.9L172.3 62.7C168.3 58.8 163 56.6 157.4 56.7C145.3 55.9 134.8 65.1 134 77.2C133.2 89.3 142.4 99.8 154.5 100.6C155.4 100.7 156.4 100.7 157.3 100.6C163.8 100.6 168.7 98.5 172.5 94.4C176.3 90.3 177.6 84.9 177.6 80.4C177.6 79.1 177.5 77.9 177.3 76.7L157.4 76.6ZM193.9 95C189.7 95 186 91.5 186 86.4C186 81.3 189.7 77.8 193.9 77.8C198.1 77.8 201.8 81.3 201.8 86.4C201.8 91.5 198.2 95 193.9 95ZM193.9 72.3C186.1 72.3 179.7 78.6 179.7 86.4C179.7 94.2 186 100.6 193.8 100.6C201.6 100.6 208 94.3 208 86.5V86.4C208.1 78.7 202.1 72.4 194.4 72.3C194.2 72.3 194.1 72.3 193.9 72.3ZM224.6 95C220.4 95 216.7 91.5 216.7 86.4C216.7 81.3 220.4 77.8 224.6 77.8C228.8 77.8 232.5 81.3 232.5 86.4C232.5 91.5 228.9 95 224.6 95ZM224.6 72.3C216.8 72.3 210.4 78.6 210.4 86.4C210.4 94.2 216.7 100.6 224.5 100.6C232.3 100.6 238.7 94.3 238.7 86.5C238.7 86.5 238.7 86.5 238.7 86.4C238.8 78.7 232.8 72.4 225.1 72.3C224.9 72.3 224.8 72.3 224.6 72.3Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4002 25.1C33.3002 26.4 32.8002 28.1 32.9002 29.8V103.3C32.8002 105 33.3002 106.7 34.4002 108L34.6002 108.2L75.4002 67V66L34.6002 24.8L34.4002 25.1Z",
    fill: "url(#paint0_linear_28_778)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 66V67L89.1 80.7L89.4 80.5L105.5 71.3C110.1 68.7 110.1 64.3 105.5 61.7L89.4 52.5L89.1 52.3L75.5 66Z",
    fill: "url(#paint1_linear_28_778)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4004 107.9C35.9004 109.5 38.4004 109.7 41.2004 108.1L89.4004 80.5L75.5004 66.5L34.4004 107.9Z",
    fill: "url(#paint2_linear_28_778)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4004 25.1L75.5004 66.5L89.4004 52.5L41.2004 24.9C40.1004 24.2 38.8004 23.8 37.5004 23.8C36.3004 23.7 35.2004 24.2 34.4004 25.1Z",
    fill: "url(#paint3_linear_28_778)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_28_778",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -33,
    y: -34,
    width: 511,
    height: 201
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M478 -33.2H-33V166.2H478V-33.2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_28_778)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_28_778",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 80,
    width: 56,
    height: 30
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4004 80.2H34.4004V109.2H89.4004V80.2Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_28_778)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.1004 80.2L41.2004 107.6C38.5004 109.1 36.1004 109 34.6004 107.6L34.4004 107.8L34.6004 108C36.1004 109.4 38.5004 109.5 41.2004 108L89.4004 80.4L89.1004 80.2Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_28_778",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 102,
    width: 3,
    height: 6
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7004 102.8H32.9004V108H34.7004V102.8Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_28_778)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4002 107.4C33.3002 106.1 32.8002 104.4 32.9002 102.7V103.2C32.8002 104.9 33.3002 106.6 34.4002 107.9L34.6002 107.7L34.4002 107.4Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_28_778",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 66,
    width: 21,
    height: 15
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.001 66.5H89.1006V80.5H109.001V66.5Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_28_778)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.501 70.8L89.1006 80.2L89.4006 80.5L105.501 71.3C107.801 70 109.001 68.2 109.001 66.5C108.801 68 107.601 69.6 105.501 70.8Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_28_778",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 23,
    width: 77,
    height: 44
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109 23.7H32.9004V66.5H109V23.7Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_28_778)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2008 25.3L105.501 62.1C107.601 63.3 108.801 64.8 109.001 66.4C109.001 64.7 107.801 62.9 105.501 61.6L41.2008 24.9C36.6008 22.3 32.8008 24.4 32.8008 29.8V30.3C32.8008 24.9 36.6008 22.7 41.2008 25.3Z",
    fill: "white"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.601 40.8H142.101C145.901 41.1 149.201 38.3 149.501 34.5C149.501 34.1 149.501 33.7 149.501 33.3C149.601 31.3 148.901 29.3 147.501 27.8C146.001 26.4 144.101 25.7 142.101 25.8H138.601V40.8ZM136.101 43.2V23.2H142.201C147.401 22.9 151.901 26.9 152.201 32.1C152.201 32.5 152.201 32.8 152.201 33.2C152.501 38.4 148.501 42.9 143.301 43.2C142.901 43.2 142.501 43.2 142.201 43.2H136.101Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.601 40.8H142.101C145.901 41.1 149.201 38.3 149.501 34.5C149.501 34.1 149.501 33.7 149.501 33.3C149.601 31.3 148.901 29.3 147.501 27.8C146.001 26.4 144.101 25.7 142.101 25.8H138.601V40.8ZM136.101 43.2V23.2H142.201C147.401 22.9 151.901 26.9 152.201 32.1C152.201 32.5 152.201 32.8 152.201 33.2C152.501 38.4 148.501 42.9 143.301 43.2C142.901 43.2 142.501 43.2 142.201 43.2H136.101Z",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 13.33
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M155.7 23.3H158.2V43.2H155.7V23.3Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 13.33
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.4 43.6C166.9 43.6 165.4 43.1 164.2 42.2C162.8 41.3 161.9 39.8 161.5 38.2L163.8 37.2C164.1 38.3 164.7 39.2 165.5 40C166.3 40.7 167.3 41.1 168.4 41.1C169.4 41.1 170.4 40.8 171.2 40.2C171.9 39.7 172.4 38.8 172.3 37.9C172.4 36.9 171.9 35.9 171.1 35.3C170 34.5 168.7 34 167.4 33.6C165.9 33.2 164.5 32.5 163.4 31.4C162.5 30.5 162.1 29.3 162.1 28C162.1 26.6 162.7 25.2 163.8 24.3C165 23.2 166.5 22.7 168.1 22.7C169.6 22.6 171 23.1 172.2 24C173.1 24.7 173.8 25.7 174.2 26.8L171.9 27.8C171.7 27.1 171.3 26.5 170.7 26C170 25.4 169.1 25.2 168.2 25.2C167.3 25.2 166.4 25.5 165.7 26C165.1 26.5 164.7 27.2 164.7 28C164.7 28.7 165.1 29.4 165.6 29.9C166.5 30.5 167.4 31 168.4 31.3C169.2 31.6 170 31.9 170.8 32.2C171.5 32.5 172.2 32.9 172.8 33.4C173.5 33.9 174 34.5 174.3 35.2C174.7 36 174.8 36.9 174.8 37.7C174.8 38.6 174.6 39.5 174.2 40.3C173.8 41 173.3 41.6 172.6 42.1C172 42.5 171.2 42.9 170.5 43.1C169.9 43.6 169.1 43.7 168.4 43.6Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M168.4 43.6C166.9 43.6 165.4 43.1 164.2 42.2C162.8 41.3 161.9 39.8 161.5 38.2L163.8 37.2C164.1 38.3 164.7 39.2 165.5 40C166.3 40.7 167.3 41.1 168.4 41.1C169.4 41.1 170.4 40.8 171.2 40.2C171.9 39.7 172.4 38.8 172.3 37.9C172.4 36.9 171.9 35.9 171.1 35.3C170 34.5 168.7 34 167.4 33.6C165.9 33.2 164.5 32.5 163.4 31.4C162.5 30.5 162.1 29.3 162.1 28C162.1 26.6 162.7 25.2 163.8 24.3C165 23.2 166.5 22.7 168.1 22.7C169.6 22.6 171 23.1 172.2 24C173.1 24.7 173.8 25.7 174.2 26.8L171.9 27.8C171.7 27.1 171.3 26.5 170.7 26C170 25.4 169.1 25.2 168.2 25.2C167.3 25.2 166.4 25.5 165.7 26C165.1 26.5 164.7 27.2 164.7 28C164.7 28.7 165.1 29.4 165.6 29.9C166.5 30.5 167.4 31 168.4 31.3C169.2 31.6 170 31.9 170.8 32.2C171.5 32.5 172.2 32.9 172.8 33.4C173.5 33.9 174 34.5 174.3 35.2C174.7 36 174.8 36.9 174.8 37.7C174.8 38.6 174.6 39.5 174.2 40.3C173.8 41 173.3 41.6 172.6 42.1C172 42.5 171.2 42.9 170.5 43.1C169.9 43.5 169.2 43.7 168.4 43.6Z",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 13.33
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M181.2 32.7H185.5C186.5 32.7 187.4 32.3 188.1 31.6C189.4 30.3 189.4 28.1 188.1 26.8C187.4 26.1 186.5 25.7 185.5 25.7H181.2V32.7ZM181.2 43.2H178.7V23.3H185.4C187 23.3 188.5 23.9 189.7 25C192 27.2 192.2 30.9 190 33.2C189.9 33.3 189.8 33.4 189.7 33.5C188.5 34.6 187 35.2 185.3 35.2H181.1V43.2H181.2Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M181.2 32.7H185.5C186.5 32.7 187.4 32.3 188.1 31.6C189.4 30.3 189.4 28.1 188.1 26.8C187.4 26.1 186.5 25.7 185.5 25.7H181.2V32.7ZM181.2 43.2H178.7V23.3H185.4C187 23.3 188.5 23.9 189.7 25C192 27.2 192.2 30.9 190 33.2C189.9 33.3 189.8 33.4 189.7 33.5C188.5 34.6 187 35.2 185.3 35.2H181.1V43.2H181.2Z",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 13.33
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M198.3 38.9C201.2 41.9 206 41.9 209 38.9C210.5 37.4 211.3 35.3 211.2 33.2C211.3 31.1 210.5 29 209 27.5C206.1 24.5 201.3 24.5 198.3 27.5C196.8 29 196 31.1 196.1 33.2C196 35.3 196.8 37.4 198.3 38.9ZM211 40.6C207 44.6 200.6 44.6 196.5 40.7C196.5 40.7 196.5 40.7 196.4 40.6C194.5 38.6 193.4 36 193.5 33.2C193.4 30.4 194.5 27.8 196.4 25.8C200.3 21.8 206.8 21.8 210.8 25.7L210.9 25.8C212.8 27.8 213.9 30.4 213.8 33.2C213.9 36 212.9 38.6 211 40.6Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M198.3 38.9C201.2 41.9 206 41.9 209 38.9C210.5 37.4 211.3 35.3 211.2 33.2C211.3 31.1 210.5 29 209 27.5C206.1 24.5 201.3 24.5 198.3 27.5C196.8 29 196 31.1 196.1 33.2C196 35.3 196.8 37.4 198.3 38.9ZM211 40.6C207 44.6 200.6 44.6 196.5 40.7C196.5 40.7 196.5 40.7 196.4 40.6C194.5 38.6 193.4 36 193.5 33.2C193.4 30.4 194.5 27.8 196.4 25.8C200.3 21.8 206.8 21.8 210.8 25.7L210.9 25.8C212.8 27.8 213.9 30.4 213.8 33.2C213.9 36 212.9 38.6 211 40.6Z",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 13.33
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M217.4 43.2V23.3H220.5L230.1 38.8H230.2L230.1 35V23.3H232.6V43.2H230L220 26.9H219.9L220 30.8V43.2H217.4Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M217.4 43.2V23.3H220.5L230.1 38.8H230.2L230.1 35V23.3H232.6V43.2H230L220 26.9H219.9L220 30.8V43.2H217.4Z",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 13.33
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M237.2 23.3H239.7V43.2H237.2V23.3Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 13.33
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M246.801 40.8H251.901C252.801 40.8 253.701 40.5 254.301 39.8C254.901 39.2 255.201 38.4 255.201 37.6C255.201 35.8 253.601 34.3 251.801 34.3H246.801V40.8ZM246.801 31.8H251.401C252.301 31.8 253.101 31.5 253.701 30.8C254.801 29.6 254.801 27.8 253.701 26.6C253.101 26 252.301 25.6 251.501 25.7H246.801V31.8ZM244.301 43.2V23.2H251.401C252.901 23.2 254.301 23.7 255.401 24.7C256.501 25.7 257.101 27.1 257.101 28.6C257.101 29.5 256.901 30.4 256.401 31.1C255.901 31.8 255.201 32.4 254.501 32.7V32.8C255.501 33.1 256.301 33.7 256.901 34.5C257.501 35.3 257.901 36.3 257.801 37.3C257.801 38.8 257.201 40.3 256.001 41.4C254.901 42.5 253.301 43 251.801 43L244.301 43.2Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M246.801 40.8H251.901C252.801 40.8 253.701 40.5 254.301 39.8C254.901 39.2 255.201 38.4 255.201 37.6C255.201 35.8 253.601 34.3 251.801 34.3H246.801V40.8ZM246.801 31.8H251.401C252.301 31.8 253.101 31.5 253.701 30.8C254.801 29.6 254.801 27.8 253.701 26.6C253.101 26 252.301 25.6 251.501 25.7H246.801V31.8ZM244.301 43.2V23.2H251.401C252.901 23.2 254.301 23.7 255.401 24.7C256.501 25.7 257.101 27.1 257.101 28.6C257.101 29.5 256.901 30.4 256.401 31.1C255.901 31.8 255.201 32.4 254.501 32.7V32.8C255.501 33.1 256.301 33.7 256.901 34.5C257.501 35.3 257.901 36.3 257.801 37.3C257.801 38.8 257.201 40.3 256.001 41.4C254.901 42.5 253.301 43 251.801 43L244.301 43.2Z",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 13.33
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M261.2 43.2V23.3H263.7V40.8H272.3V43.3H261.2V43.2Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M261.2 43.2V23.3H263.7V40.8H272.3V43.3H261.2V43.2Z",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 13.33
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M287.101 25.7H278.101V32H286.201V34.4H278.101V40.7H287.101V43.2H275.601V23.3H287.101V25.7Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M287.101 25.7H278.101V32H286.201V34.4H278.101V40.7H287.101V43.2H275.601V23.3H287.101V25.7Z",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 13.33
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M309.3 25.7H300.3V32H308.4V34.4H300.2V40.7H309.2V43.2H297.7V23.3H309.2V25.7H309.3Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M309.3 25.7H300.3V32H308.4V34.4H300.2V40.7H309.2V43.2H297.7V23.3H309.2V25.7H309.3Z",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 13.33
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M313.2 43.2V23.3H316.3L325.9 38.8H326L325.9 35V23.3H328.4V43.2H325.8L315.7 26.9H315.6L315.7 30.8V43.2H313.2Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M313.2 43.2V23.3H316.3L325.9 38.8H326L325.9 35V23.3H328.4V43.2H325.8L315.7 26.9H315.6L315.7 30.8V43.2H313.2Z",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 13.33
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_778",
    x1: 72.5473,
    y1: 28.5905,
    x2: 16.5975,
    y2: 84.5402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_778",
    x1: 111.266,
    y1: 66.4808,
    x2: 31.5838,
    y2: 66.4808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28_778",
    x1: 81.6498,
    y1: 74.3104,
    x2: 6.40165,
    y2: 149.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28_778",
    x1: 23.9515,
    y1: 0.989514,
    x2: 57.551,
    y2: 34.5891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 445.1,
    height: 132.9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google_play.38390448dc887c7af60e9b082a9dcb84.svg";
export { ForwardRef as ReactComponent };